import uuid from 'uuid';
import type { LocalViewId } from './types.tsx';

export const generateLocalViewId = (): LocalViewId => uuid();
